var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLoading && _vm.orderDetails != null
    ? _c("div", [
        _c("div", { staticClass: "md-layout" }, [
          _c("div", { staticClass: "md-layout-item" }, [
            _c("div", { staticClass: "custom-toolbar" }, [
              _c(
                "div",
                { staticClass: "custom-toolbar-start" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "Orders List",
                        },
                      },
                    },
                    [_c("h3", { staticClass: "title" }, [_vm._v("Order List")])]
                  ),
                  _c("h3", { staticClass: "title" }, [
                    _vm._v("   >    " + _vm._s(_vm.orderDetails.orderNumber)),
                  ]),
                ],
                1
              ),
              !_vm.$root.isMobileOnly
                ? _c("div", { staticClass: "custom-toolbar-end" }, [
                    _c("div", { staticClass: "status-box-container" }, [
                      _c(
                        "div",
                        {
                          staticClass: "order-status-box",
                          class:
                            "status-" +
                            _vm.$_getBadgeStatusColor(_vm.orderDetails.status),
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.orderDetails.status) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "header-button-container" },
                      [
                        _vm.hasBulkSmsAccess
                          ? _c("SendSmsButton", {
                              attrs: {
                                "class-name": "header-button",
                                "order-id": _vm.orderDetails.orderId,
                                "order-contact": _vm.orderDetails.contact,
                              },
                            })
                          : _vm._e(),
                        _c(
                          "md-button",
                          {
                            staticClass: "md-warning",
                            attrs: {
                              title: "Update order",
                              disabled: _vm.isFetchingStops,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.updateOrder(_vm.orderDetails.orderId)
                              },
                            },
                          },
                          [_c("span", [_vm._v("Edit")])]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "order-details-grid" }, [
          _c(
            "div",
            { staticClass: "order-details-section" },
            [
              _c(
                "md-card",
                [
                  _c(
                    "md-card-header",
                    { staticClass: "md-card-header-icon md-card-header-blue" },
                    [
                      _c(
                        "div",
                        { staticClass: "card-icon" },
                        [_c("md-icon", [_vm._v("description")])],
                        1
                      ),
                    ]
                  ),
                  _c("md-card-content", [
                    _c("div", { staticClass: "multiple-details-box" }, [
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Order Number")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.orderDetails.orderNumber) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Purchase Order Number")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.orderDetails.purchaseOrderNumber) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Source Reference")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.orderDetails.sourceReference) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Payment date")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm._f("dateFormat")(
                                  _vm.orderDetails.paymentDate,
                                  _vm.DATE_TYPES.standardDate
                                )
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "multiple-details-box" }, [
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Customer Name")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.orderDetails.customer != null
                                  ? _vm.orderDetails.customer.customerName
                                  : ""
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Team Region")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.orderDetails.teamRegion != null
                                  ? _vm.orderDetails.teamRegion.name
                                  : ""
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Service Area")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.orderDetails.serviceArea) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Service Package")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.orderDetails.servicePackage) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Handling Method")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.orderDetails.handlingMethod) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "multiple-details-box" }, [
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Order date")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm._f("dateFormat")(
                                  _vm.orderDetails.orderDate,
                                  _vm.DATE_TYPES.standardDate
                                )
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Expected Delivery Date")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm._f("dateFormat")(
                                  _vm.orderDetails.expectedDeliveryDate,
                                  _vm.DATE_TYPES.standardDate
                                )
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Ready Available Pickup Date")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm._f("dateFormat")(
                                  _vm.orderDetails.readyPickupAvailableDate,
                                  _vm.DATE_TYPES.standardDate
                                )
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "details-box" }, [
                        _c("label", [_vm._v("Ready Available Delivery Date")]),
                        _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm._f("dateFormat")(
                                  _vm.orderDetails.readyDeliveryAvailableDate,
                                  _vm.DATE_TYPES.standardDate
                                )
                              ) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm.orderDetails.pickupAddress != null
                      ? _c("div", { staticClass: "address-details" }, [
                          _c("div", { staticClass: "details-box" }, [
                            _c("label", [_vm._v("Pickup Address")]),
                            _vm.orderDetails.pickupAddress.name
                              ? _c("div", { staticClass: "address-name" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.orderDetails.pickupAddress.name
                                      ) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.orderDetails.pickupAddress.address)
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.orderDetails.shippingAddress != null
                      ? _c("div", { staticClass: "address-details" }, [
                          _c("div", { staticClass: "details-box" }, [
                            _c("label", [_vm._v("Delivery Address")]),
                            _vm.orderDetails.shippingAddress.name
                              ? _c("div", { staticClass: "address-name" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.orderDetails.shippingAddress.name
                                      ) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.orderDetails.shippingAddress.address)
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.user.vehicleCapacityUnitsConfiguration != null &&
                    _vm.user.vehicleCapacityUnitsConfiguration.length > 0
                      ? _c("div", { staticClass: "multiple-details-box" }, [
                          _c("div", { staticClass: "details-box" }, [
                            _c("label", [_vm._v("Quantity")]),
                            _c("span", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.orderDetails.quantity) +
                                  "\n                            "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "details-box" }, [
                            _c("label", [_vm._v("Volume")]),
                            _vm.orderDetails.volume
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.orderDetails.volume) +
                                      " " +
                                      _vm._s(_vm.volumeSymbol)
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "details-box" }, [
                            _c("label", [_vm._v("Weight")]),
                            _vm.orderDetails.weight
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.orderDetails.weight) +
                                      " " +
                                      _vm._s(_vm.weightSymbol)
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.orderDetails.skills.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "details-box md-chips md-primary md-theme-default md-has-placeholder md-theme-default",
                          },
                          [
                            _c("label", [_vm._v("Required skills:")]),
                            _vm._l(
                              _vm.orderDetails.skills,
                              function (skill, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "md-chip md-theme-default custom-chip",
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(skill) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "details-box" }, [
                      _c("label", [_vm._v("Delivery Instructions")]),
                      _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.orderDetails.deliveryInstructions) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "details-box" }, [
                      _c("label", [_vm._v("Notes")]),
                      _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.orderDetails.notes) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "details-box" }, [
                      _c("label", [_vm._v("Schedule Link")]),
                      _c("div", [
                        _vm.orderDetails.scheduleLink
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.orderDetails.scheduleLink,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("md-icon", [_vm._v("place")]),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.orderDetails.scheduleLink) +
                                    "\n                            "
                                ),
                              ],
                              1
                            )
                          : _vm.orderDetails.scheduleLink == null &&
                            !_vm.isReadOnlyUser
                          ? _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.createSchedulingLink(
                                      _vm.orderDetails.orderId
                                    )
                                  },
                                },
                              },
                              [
                                _c("md-icon", [_vm._v("add_location_alt")]),
                                _vm._v(
                                  "\n                                Create scheduling link\n                            "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "contact-details-section" },
            [
              _c("contact-details", {
                attrs: { "stop-details": _vm.orderDetails },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "stops-table-section" },
            [
              _c(
                "md-card",
                [
                  _c(
                    "md-card-header",
                    { staticClass: "md-card-header-icon md-card-header-blue" },
                    [
                      _c(
                        "div",
                        { staticClass: "card-icon" },
                        [_c("md-icon", [_vm._v("drive_eta")])],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "card-header-actions" },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-just-icon md-round md-white",
                              attrs: {
                                title: "Refresh stops",
                                disabled: _vm.isRefreshing,
                              },
                              on: { click: _vm.refreshStops },
                            },
                            [
                              _c(
                                "md-icon",
                                { class: { rotating: _vm.isRefreshing } },
                                [_vm._v("refresh")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "md-card-content",
                    [
                      _c("StopsTable", {
                        attrs: {
                          "order-stops": _vm.orderStops,
                          "is-loading":
                            _vm.fetchStopStatusStateMachine === "pending",
                          "team-members": _vm.teamMembers,
                          "table-column-options": _vm.tableColumnOptions,
                          "column-keys": _vm.columnKeys,
                          "table-column-key-options": _vm.tableColumnKeyOptions,
                          "can-clone-jobs": _vm.canCloneJobs,
                        },
                        on: {
                          statusHistoryUpdated: _vm.onChangedStopStatus,
                          assignedUser: _vm.onAssignedUser,
                          columnSwitch: _vm.$_handleColumnSwitch,
                          trackingLinkClick: _vm.openTrackingLink,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "main-container" }, [
          _c("div", { staticClass: "left-container" }, [
            _c(
              "div",
              { staticClass: "order-lines-section" },
              [
                _c(
                  "md-card",
                  [
                    _c(
                      "md-card-header",
                      {
                        staticClass: "md-card-header-icon md-card-header-rose",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card-icon" },
                          [_c("md-icon", [_vm._v("receipt_long")])],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "md-card-content",
                      [
                        _vm.orderDetails.orderLines.length > 0
                          ? _c(
                              "md-table",
                              [
                                _c(
                                  "md-table-row",
                                  [
                                    _c("md-table-head", [
                                      _vm._v("Product Reference"),
                                    ]),
                                    _c("md-table-head", [_vm._v("Qty")]),
                                    _c("md-table-head", [_vm._v("Status")]),
                                  ],
                                  1
                                ),
                                _vm._l(
                                  _vm.orderDetails.orderLines,
                                  function (orderLine) {
                                    return _c(
                                      "md-table-row",
                                      { key: orderLine.orderLineId },
                                      [
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                orderLine.productReference
                                              ) +
                                              "\n                                    "
                                          ),
                                          orderLine.productVariant != null
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                                        (" +
                                                    _vm._s(
                                                      orderLine.productVariant
                                                        .size
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      orderLine.productVariant
                                                        .colour
                                                    ) +
                                                    ")\n                                    "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(_vm._s(orderLine.quantity)),
                                        ]),
                                        _c("md-table-cell", [
                                          _c(
                                            "span",
                                            { staticClass: "custom-badge" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(orderLine.status) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _c("div", [
                              _c("p", { staticClass: "no-result-message" }, [
                                _vm._v(
                                  "No existing order lines for this order."
                                ),
                              ]),
                            ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "item-lines-section" },
              [
                _c(
                  "md-card",
                  [
                    _c(
                      "md-card-header",
                      {
                        staticClass: "md-card-header-icon md-card-header-green",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card-icon" },
                          [_c("md-icon", [_vm._v("inventory_2")])],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "md-card-content",
                      [
                        _vm.orderDetails.items.length > 0
                          ? _c(
                              "md-table",
                              { staticClass: "itemline-table" },
                              [
                                _c(
                                  "md-table-row",
                                  [
                                    _c("md-table-head", [_vm._v("Status")]),
                                    _c("md-table-head", [_vm._v("Barcode")]),
                                    _c("md-table-head", [_vm._v("Volume")]),
                                    _c("md-table-head", [_vm._v("Weight")]),
                                    _c("md-table-head", [
                                      _vm._v("Description"),
                                    ]),
                                    _c("md-table-head", [_vm._v("SKU")]),
                                    _c("md-table-head"),
                                  ],
                                  1
                                ),
                                _vm._l(
                                  _vm.orderDetails.items,
                                  function (item, index) {
                                    return _c(
                                      "md-table-row",
                                      {
                                        key: item.itemId,
                                        staticClass: "expandable-row top-align",
                                      },
                                      [
                                        _c("md-table-cell", [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "custom-badge",
                                              class:
                                                "inventory-status-" +
                                                item.status
                                                  .toLowerCase()
                                                  .replace(/\s+/g, ""),
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "inputs.itemStatuses." +
                                                        item.status
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c(
                                          "md-table-cell",
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "ref-link",
                                                attrs: {
                                                  title: "View item details",
                                                  to: {
                                                    name: "Inventory Details",
                                                    params: {
                                                      itemId: item.itemId,
                                                    },
                                                  },
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.barcode) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            _vm._s(item.volume) +
                                              " " +
                                              _vm._s(_vm.volumeSymbol)
                                          ),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            _vm._s(item.weight) +
                                              " " +
                                              _vm._s(_vm.weightSymbol)
                                          ),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.description) +
                                              "\n                                    "
                                          ),
                                          _vm.expandedRows[index]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "expanded-content",
                                                },
                                                [
                                                  item.itemLines.length > 0 &&
                                                  item.itemLines.filter(
                                                    function (x) {
                                                      return x.quantity > 1
                                                    }
                                                  ).length >= 2
                                                    ? _c(
                                                        "md-table",
                                                        {
                                                          staticClass:
                                                            "mini-table",
                                                        },
                                                        [
                                                          _c("md-table-head", [
                                                            _vm._v("Qty"),
                                                          ]),
                                                          _c("md-table-head", [
                                                            _vm._v("Product"),
                                                          ]),
                                                          _vm._l(
                                                            item.itemLines,
                                                            function (line) {
                                                              return _c(
                                                                "md-table-row",
                                                                {
                                                                  key: line.itemLineId,
                                                                },
                                                                [
                                                                  _c(
                                                                    "md-table-cell",
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                    " +
                                                                          _vm._s(
                                                                            line.quantity
                                                                          ) +
                                                                          "\n                                                "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "md-table-cell",
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                    " +
                                                                          _vm._s(
                                                                            line.productReference
                                                                          ) +
                                                                          "\n                                                "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                        _c("md-table-cell", [
                                          _vm._v(_vm._s(item.sku)),
                                        ]),
                                        _c(
                                          "md-table-cell",
                                          [
                                            item.itemLines.length > 0 &&
                                            item.itemLines.filter(function (x) {
                                              return x.quantity > 1
                                            }).length >= 2
                                              ? _c(
                                                  "md-button",
                                                  {
                                                    staticClass:
                                                      "md-icon-button md-primary",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleExpand(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("md-icon", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.expandedRows[
                                                              index
                                                            ]
                                                              ? "keyboard_arrow_up"
                                                              : "keyboard_arrow_down"
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _c("div", [
                              _c("p", { staticClass: "no-result-message" }, [
                                _vm._v("No existing items for this order."),
                              ]),
                            ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            !_vm.isIndividualUser
              ? _c(
                  "div",
                  { staticClass: "charges-section" },
                  [
                    ((_vm.orderDetails.chargeLines &&
                      _vm.orderDetails.chargeLines.length > 0) ||
                      _vm.orderDetails.customerId) &&
                    (_vm.canAccessRates || _vm.isAdmin || _vm.isReadOnlyUser)
                      ? _c("charge-rates-list", {
                          attrs: {
                            "charge-lines": _vm.orderDetails.chargeLines || [],
                            "order-details": _vm.orderDetails,
                            title: "Charges",
                            "has-invoice":
                              _vm.orderDetails.customerInvoiceId !== null,
                          },
                          on: { updateOrderDetails: _vm.fetchOrderDetails },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "notes-section" },
              [
                _c("notes", {
                  attrs: {
                    list: _vm.orderDetails.orderNotes,
                    "order-id": _vm.orderDetails.orderId,
                  },
                  on: { notesAdded: _vm.handleAddedOrderNote },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "right-container" }, [
            _vm.$root.isDesktop
              ? _c(
                  "div",
                  { staticClass: "md-layout-item" },
                  [
                    _c(
                      "md-card",
                      [
                        _c(
                          "md-card-header",
                          {
                            staticClass:
                              "md-card-header-icon md-card-header-warning",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-icon" },
                              [_c("md-icon", [_vm._v("history")])],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "md-card-content",
                          [
                            _vm.statusHistory.length > 0
                              ? _c(
                                  "time-line",
                                  { attrs: { plain: "", type: "simple" } },
                                  _vm._l(
                                    _vm.statusHistory,
                                    function (history, index) {
                                      return _c(
                                        "time-line-item",
                                        {
                                          key: index,
                                          attrs: {
                                            inverted: "",
                                            "badge-type":
                                              "status-" +
                                              _vm.$_getBadgeStatusColor(
                                                history.newStatus
                                              ),
                                            "badge-icon": "place",
                                            "is-clickable": false,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "custom-badge",
                                              class:
                                                "status-" +
                                                _vm.$_getBadgeStatusColor(
                                                  history.newStatus
                                                ),
                                              attrs: { slot: "header" },
                                              slot: "header",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(history.newStatus) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "time",
                                              attrs: { slot: "headerTime" },
                                              slot: "headerTime",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm._f("dateTimeFormat")(
                                                      history.actionDate,
                                                      _vm.DATE_TYPES
                                                        .standardDate
                                                    )
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "h6",
                                            {
                                              attrs: { slot: "footer" },
                                              slot: "footer",
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "ti-time",
                                              }),
                                              _vm._v(
                                                "\n\n                                    By " +
                                                  _vm._s(
                                                    history.changedByUserFullName
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _c("p", { staticClass: "grayedout-text" }, [
                                  _vm._v("No Status History Available"),
                                ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }